export const RESPONSIVA_STATUS_NONE = "NONE";
export const RESPONSIVA_STATUS_PENDING = "PENDING";
export const RESPONSIVA_STATUS_VALIDATED = "VALIDATED";
export const RESPONSIVA_STATUS_REJECTED = "REJECTED";
export const RESPONSIVA_STATUS_REVOKED = "REVOKED";
export const RESPONSIVA_STATUS_PENDING_AFTER_REJECTED = "PENDING_AFTER_REJECTED";
export const RESPONSIVA_STATUS_PENDING_SUPER_RESPONSIBLE = "PENDING_SUPER_RESPONSIBLE"; //pendiente de firma de super responsable (para los roles de admin)
export const RESPONSIVA_STATUS_PENDING_SUPER_RESPONSIBLE_AFTER_REJECTED = "PENDING_SUPER_RESPONSIBLE_AFTER_REJECTED"; //pendiente de firma de super responsable (para los roles de admin)

export const RESPONSIVA_STATUS = [
  {
    value: RESPONSIVA_STATUS_PENDING,
    text: "responsivas.statusOp.pending",
    color: "#f57e20",
  },
  {
    value: RESPONSIVA_STATUS_VALIDATED,
    text: "responsivas.statusOp.validated",
    color: "#43a047",
  },
  {
    value: RESPONSIVA_STATUS_REJECTED,
    text: "responsivas.statusOp.rejected",
    color: "#e53935",
  },
  {
    value: RESPONSIVA_STATUS_REVOKED,
    text: "responsivas.statusOp.revoked",
    color: "#37474f",
  },
  {
    value: RESPONSIVA_STATUS_PENDING_AFTER_REJECTED,
    text: "responsivas.statusOp.pendingAfterRejected",
    color: "#e65100",
  },
];
export const RESPONSIVA_STATUS_SUPER_RESPONSIBLE = RESPONSIVA_STATUS;
// .concat([
//   {
//     value: RESPONSIVA_STATUS_PENDING_SUPER_RESPONSIBLE,
//     text: "responsivas.statusOp.pendingSuperResponsible",
//     color: "#c2185b",
//   },
//   {
//     value: RESPONSIVA_STATUS_PENDING_SUPER_RESPONSIBLE_AFTER_REJECTED,
//     text: "responsivas.statusOp.pendingSuperResponsibleAfterRejected",
//     color: "#e65100",
//   },
// ]);

export const REVOCATION_REASON_PERMISSIONS_CHANGED = "PERMISSIONS_CHANGED";
export const REVOCATION_REASON_YEAR_REVOCATION = "YEAR_REVOCATION";
export const REVOCATION_REASONS = [
  {
    value: REVOCATION_REASON_PERMISSIONS_CHANGED,
    text: "responsivas.statusAdvices.revokedReasonsOp.PERMISSIONS_CHANGED",
  },
  {
    value: REVOCATION_REASON_YEAR_REVOCATION,
    text: "responsivas.statusAdvices.revokedReasonsOp.YEAR_REVOCATION",
  },
];
